import { type GboxTimelineFeed } from "@/lib/gboxTimeline"

export const PLATFORM_SCIENCE_TIMELINE_NS =
  "urn:slickshift:platform-science-timeline:0"
export const PLATFORM_SCIENCE_TIMELINE_COMMAND_NODE =
  "get_platform_science_timeline_view"

export type PlatformScienceTimelineFeed = GboxTimelineFeed
